import PropTypes from "prop-types";
import { Navigate, Outlet } from "react-router";
import { useSelector } from "react-redux";

import logoSmall from "./assets/images/empower-logo-box.png";
import logoLarge from "./assets/images/empower-logo.png";

import Wrapper from "./components/common/Wrapper";

const AppWrapper = ({ children }) => {
  const auth = useSelector((state) => state.auth);
  // TODO: check sites here
  const { status } = auth;

  if (status !== 1) {
    const referrer = window.location.pathname + window.location.search;
    let redirectTo = "/auth/login";
    if (referrer.length) {
      redirectTo += "?referrer=" + encodeURIComponent(referrer);
    }
    return <Navigate to={redirectTo} />;
  }

  return (
    <Wrapper
      header={{
        logo: {
          image: {
            small: logoSmall,
            large: logoLarge,
          },
          title: "Empower",
          target: "/",
        },
      }}
    >
      {children ?? <Outlet />}
    </Wrapper>
  );
};

AppWrapper.propTypes = {
  children: PropTypes.node,
};

export default AppWrapper;
